import {a, useSpring} from 'react-spring';
import styled from '@emotion/styled';

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  min-height: calc(100vh - var(--header-height) - var(--regi-nav-height));
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const LoaderContainer2 = styled.div`
  position: absolute;
  width: 100%;
  min-height: calc(100vh - var(--header-height) - var(--regi-nav-height));
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
`;

export const Wrapper = styled.svg`
  width: 10%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > path,
  g {
    transform-origin: center center;
  }
`;

export const DefaultLoader = () => {
  const letterA = useSpring({
    from: { scaleX: 1 },
    to: { scaleX: -1 },
    loop: true,
  });

  const bow = useSpring({
    from: { scaleX: -1 },
    to: { scaleX: 1 },
    loop: true,
  });

  return (
    <Wrapper viewBox="0 0 20.069 29.887" xmlns="http://www.w3.org/2000/svg">
      <a.path
        d="m5.198 10.035a4.837 4.837 0 1 1 9.674 0v19.853h5.2v-19.853a10.035 10.035 0 1 0 -20.069 0v19.853h5.2z"
        fill="#287982"
        style={letterA}
      />
      <a.g fill="#fb4856" style={bow}>
        <path d="m6.679 21.674c-.541-.258-.49-3.866 0-4.227s2.906.885 2.906 2.1-2.364 2.385-2.906 2.127z" />
        <path d="m13.37 21.674c.541-.258.49-3.866 0-4.227s-2.906.885-2.906 2.1 2.363 2.385 2.906 2.127z" />
        <path d="m10.024 18.677a.876.876 0 0 1 .876.876.876.876 0 0 1 -.876.876.876.876 0 0 1 -.876-.876.876.876 0 0 1 .876-.876z" />
      </a.g>
    </Wrapper>
  );
};

export default DefaultLoader;
